import {
    FETCH_PLAYER_TICKET_REQUEST,
    FETCH_PLAYER_TICKET_SUCCESS,
    FETCH_PLAYER_TICKET_FAILURE,
 
  } from '../actions/playerTicketAction';
  
  const initialState = {
    ticketListData: [],
    ticketDetails:{},
    loading: false,
    error: null,
  };
  
  const playerTicketReducer = (state = initialState, action) => {
    
    switch (action.type) {
      case FETCH_PLAYER_TICKET_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case FETCH_PLAYER_TICKET_SUCCESS:
        console.log('action>>', action);
        return {
          ...state,
          loading: false,
          ticketListData: action.payload, // Fix here
          error: null,
        };
      case FETCH_PLAYER_TICKET_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default playerTicketReducer;